<template>
  <el-dialog
    :title="title"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="import-dialog"
    top="40px"
    append-to-body
    width="1400px"
    @close="onCancel">
    <div style="height: 100%;position: relative;background: #f5f5f5;">
      <template v-if="type === 2">
<!--        <div class="box title">计划管理</div>-->
        <div style="display: flex;justify-content: space-between;" class="box row">
          <div class="row">
            <div class="header-text">商品ID：{{rowList.thirdProductId}}</div>
            <div class="header-text">商品名称：{{rowList.productName}}</div>
          </div>
          <div @click="addPlan" class="add">添加计划</div>
        </div>
      </template>
      <div v-if="type === 1" class="box row">
        <div class="header-num">
          <div class="yuan">1</div>
          已选 {{rowAdd.length}} 件推广商品
        </div>
        <div  class="header-set">
          <div class="yuan">2</div>
          佣金策略设置
        </div>
      </div>
      <div class="box" v-loading="loading">
        <el-tabs v-model="activeName" @tab-click="handleChange">
          <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
        <div class="list-container">
          <div class="list-header">
            <div>
              <template v-if="activeName === '3'">
                <span style="background: #f3f4f6;padding: 4px 8px;">
                <i class="el-icon-s-custom"></i>全部达人
              </span>
              </template>
            </div>
<!--            <div @click="handleAdd" class="add" v-if="activeName !== '3' && type === 2">+添加达人</div>-->
          </div>
          <div class="list">
<!--            短视频定向-->
            <el-form v-if="type === 1" :model="form1" ref="formRef1">
              <div v-for="(item,index) in form1.items" :key="index" class="item">
                <div style="margin-right: 10px;">
                  <el-form-item :error="item.errorNamne" label="" label-width="">
                    <el-input
                      v-model="item.planName"
                      style="width: 200px;"
                      placeholder="编辑名字"
                      @input="handleInput($event, index,'planName')"
                    >
                    </el-input>
                  </el-form-item>
                </div>
                <div class="item-box">
                  <div class="item-box-left">商品ID：</div>
                  <div class="item-box-right">{{item.thirdProductId}}</div>
                </div>
                <div class="item-box">
                  <div class="item-box-left">商品名称：</div>
                  <div class="item-box-right">{{item.productName}}</div>
                </div>
                <div v-if="activeName !== '3'" class="item-box" style="position: relative;">
                  <div class="item-box-left">{{item.darens.length}}个达人</div>
                  <div v-if="item.errorDarens" style="position: absolute;bottom: 4px;left: 0;color:#F56C6C;font-size: 12px;">请添加达人</div>
                </div>
                <div v-if="activeName === '3'" class="item-box-el-form">
                  <el-form-item :error="item.error" label="佣金设置" label-width="100px">
                    <el-input
                      v-model="item.commissionRate"
                      style="width: 200px;"
                      :placeholder="activeName === '3' ? '1~29' : '1~29'"
                      @input="handleInput($event, index,'commissionRate')"
                      @blur="handleBlur($event, index)"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </div>
                <div v-if="activeName !== '3'" @click="handleAdd(item)" class="add item-box">
                  <span>+添加达人</span>
                </div>
                <div v-if="activeName === '1'" class="picker-container">
                  <el-form-item label="请选择开始和结束时间" prop="grantTimeArr" label-width="160px" :error="timeErr">
                    <el-date-picker
                      style="width: 400px;"
                      v-model="form1.grantTimeArr"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetimerange"
                      align="right"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      range-separator="至"
                      :default-time="['00:00:00', '23:59:59']"
                      :clearable="false"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="请输入计划取消后的有效时间" label-width="200px" :error="timeDayErr">
                    <el-input
                      v-model="form1.commissionDuration"
                      style="width: 140px;"
                      @input="handleInput($event, index,'commissionDuration')"
                      @blur="handleBlur($event, index)"
                    >
                      <template slot="append">天</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div v-if="activeName === '1'" style="height: 50px;"></div>
            </el-form>
<!--            直播定向-->
            <el-form v-if="type === 2 && form.items.length" :model="form" ref="form">
              <div v-if="activeName === '1' || activeName === '2'" class="search-container">
                <el-input v-model="searchVal" placeholder="请输入抖音ID，多个抖音ID之间用英文逗号隔开" style="width: 400px;margin-right: 10px"></el-input>
                <el-button type="warning" @click="onFormSearch">搜索</el-button>
                <el-button type="warning" plain @click="onFormReset">重置</el-button>
              </div>
              <div v-for="(item,index) in form.items" :key="index" class="items-row">
                <div class="item" style="margin-top:10px;">
                  <div class="item-box" v-if="activeName === '1' || activeName === '2'">
                    <el-checkbox style="margin-right: 10px;" v-model="item.checked"></el-checkbox>
                  </div>
                  <div class="item-box">
                    <div class="item-box-left" style="width: 60px;">计划ID：</div>
                    <div class="item-box-right" style="width: 160px;">{{item.planId}}</div>
                  </div>
                  <div class="item-box">
                    <div class="item-box-left">计划名称：</div>
                    <div class="item-box-right">{{item.planName}}</div>
                  </div>
                  <div v-if="activeName !== '3'" class="item-box">
                    <div class="item-box-left">抖音ID：</div>
                    <div class="item-box-right">{{item.douyinId}}</div>
                  </div>
                  <div class="item-box-el-form">
                    <el-form-item :error="item.error" label="佣金设置" label-width="100px">
                      <el-input
                        v-model="item.commissionRate"
                        style="width: 200px;"
                        :placeholder="activeName === '3' ? '1~29' : '1~29'"
                        @input="handleInput($event, index,'commissionRate')"
                        @blur="handleBlur($event, index)"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </div>
                  <div v-if="['1','2'].includes(activeName)" class="item-box-el-form">
                    <el-form-item label="团长总佣" label-width="100px">
                      <div>
                        {{ item.agentCommissionRate || '-' }} %
                      </div>
                    </el-form-item>
                  </div>
                  <div v-if="item.status === 1" @click="handleDelete([item])" class="item-box add">关闭</div>
                </div>
                <div v-if="activeName === '1'" class="">
                  <div style="display: flex;margin-bottom: 10px;">
                    <div style="min-width: 300px;margin-right: 45px;">
                      开始时间和结束时间：
                      <span v-if="item.startTime">{{item.startTime
                        }}-{{item.endTime}}</span>
                    </div>
                    <div style="min-width: 300px;">计划取消后有效时间：{{item.commissionDuration}}</div>
                  </div>
                </div>
              </div>
              <div v-if="activeName === '1'" style="height: 50px;"></div>
            </el-form>
            <div v-else-if="!loading && type === 2 && !form.items.length" style="display: flex;flex-direction: column;align-items: center;justify-content: center;height: 100%;">
              <img style="width: 200px;height: 200px;" src="https://im.taototo.cn/mini-img/noData-bg.jpg">
              <div class="no-data-text">暂无数据</div>
            </div>
          </div>
        </div>
      </div>

      <div class="btns-coantainer">
        <div class="batchSet">
          <template v-if="(activeName === '1' || activeName === '2') && type === 2">
            <el-checkbox :disabled="!form.items.length" style="margin-right: 10px;" v-model="checkedAll" @change="changeCheckedAll">全选</el-checkbox>
            <div style="margin-right: 10px;">{{ checkedItemsCount }}/{{form.items.length}}</div>
            <el-button type="warning" :disabled="!checkedItemsCount" @click="batchSet"
            >批量设置佣金</el-button>
            <el-button type="danger" :disabled="!checkedItemsCount" @click="handleDeleteList"
            >批量关闭</el-button>
          </template>
        </div>
        <div>
          <el-button type="warning" plain @click="onCancel">取消</el-button>
          <el-button :loading="submitLoading" type="warning" @click="submit"
          >提交</el-button
          >
        </div>
      </div>
    </div>
    <addExpertPop
      v-if="addExpertPopVisible"
      v-model="addExpertPopVisible"
      :oldDarens = "oldDarens"
      @close="addExpertPopVisible = false"
      @expertSubmit="handleExpertSubmit"
    ></addExpertPop>
    <manageDetailPopNew ref="manageDetailPopNewRef" @refresh="handleRefresh"></manageDetailPopNew>
    <detailBatchSetPop ref="detailBatchSetPopRef" @submit="handleBatchSetSubmit"></detailBatchSetPop>
  </el-dialog>
</template>

<script>
import addExpertPop from "./addExpertPop.vue";
import {matchNegativePart3,matchFractionalPart2,matchIntegerNew} from "@/utils/regExp.js";
import manageDetailPopNew from './manageDetailPopNew.vue';
import detailBatchSetPop from './detailBatchSetPop.vue'
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  name: "manageDetailPop",
  components: {manageDetailPopNew, addExpertPop,detailBatchSetPop},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      // 临时 ，默认0
      type:0,
      title:'计划管理',
      addExpertPopVisible:false,
      loading:false,
      dialogVisible: false,
      submitLoading: false,
      activeName:'3',
      tabsList:[
        {
          label: '通用计划',
          name: '3',
        },
        {
          label: '短视频定向计划',
          name: '1',
        },
        {
          label: '直播定向计划',
          name: '2',
        }
      ],
      form1Default:[],
      form1: {
        grantTimeArr:"",
        commissionDuration: '',
        items :[]
      },
      form: {
        grantTimeArr:"",
        commissionDuration: '',
        items :[]
      },
      formDefault:{},
      timeErr:'',
      addDarenItem:null,
      oldDarens:[],
      rowList:null,
      rowAdd:[],
      planDetails:[],
      timeDayErr:'',
      checkedAll: false,
      searchVal:'',
      searchList:[],
      oldFormItems:[], //搜索前数据
    }
  },
  computed: {
    checkedItemsCount() {
      let length = this.form.items.filter(item => item.checked).length;
      if(length === this.form.items.length) {
        this.checkedAll = true
      }else{
        this.checkedAll = false
      }
      return length
    },
  },
  watch: {
  },
  methods:{
    changeCheckedAll(e) {
      console.log(e,'eee')
      this.form.items.forEach(item => {
        item.checked = e;
      });
    },
    handleBatchSetSubmit(num) {
      console.log(num,'handleBatchSetSubmit===批量设置佣金')
      this.form.items.forEach(item => {
        if(item.checked) {
          item.commissionRate = num
        }
      })
    },
    onFormSearch() {
      if(this.searchVal.trim().length === 0) {
        this.$message({
          message: '请输入抖音ID',
          type: 'warning',
        })
        return
      }
      let searchValList = this.searchVal.split(',')
      console.log(searchValList,'searchValList')
      let list = []
      let result = JSON.parse(JSON.stringify(this.form.items))
      if(this.searchList.length) {
        result = this.oldFormItems.map(item => {
          const found = this.searchList.find(s => s.planId === item.planId)
          return found ? found : item
        })
        console.log(result,'resultresultresult')
        list = result.filter(item => {
          console.log(item)
          return searchValList.includes(item.douyinId)
        })
      }else{
        list = this.form.items.filter(item => {
          console.log(item)
          return searchValList.includes(item.douyinId)
        })
      }
      console.log(list,'list')
      if(!list.length) {
        this.$message({
          message: '搜索对象不存在',
          type: 'warning',
        })
        return
      }

      // if(this.searchList.length) {
      //   result = this.oldFormItems.map(item => {
      //     const found = this.searchList.find(s => s.planId === item.planId)
      //     return found ? found : item
      //   })
      //   console.log(result,'resultresultresult')
      // }
      this.searchList = list
      this.oldFormItems = result
      this.form.items = list
    },
    onFormReset() {
      if(this.searchList.length) {
        const result = this.oldFormItems.map(item => {
          const found = this.searchList.find(s => s.planId === item.planId)
          return found ? found : item
        })
        console.log(result,'resultresultresult')
        this.form.items = result
        this.searchList = []
        this.oldFormItems = []
      }
      this.searchVal = ''
    },
    batchSet() {
      let checkedItems = this.form.items.filter(item => item.checked);
      if(checkedItems.length === 0) {
        this.$message({
          message: '请选择要设置佣金的计划',
          type: 'warning',
        })
        return
      }
      this.$refs.detailBatchSetPopRef.open(checkedItems.length)
    },
    async handleRefresh() {
      console.log('handleRefresh===111222333333=新增编辑后刷新')
      this.$emit('refresh')
      this.loading = true
      await this.getDetaile()
      this.loading = false
    },
    addPlan() {
      console.log(this.formDefault,this.planDetails,'addPlan===添加计划')
      this.$refs.manageDetailPopNewRef.open(3, this.formDefault,this.planDetails,this.rowList);
    },
    getTime() {
      const startTime = this.$moment().add(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const endTime = this.$moment(startTime, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');

      return {
        startTime,
        endTime,
      };
    },
    handleExpertSubmit(list) {
      console.log(list,'handleExpertSubmithandleExpertSubmit===添加达人')
      if(this.type === 1) {
        let index = this.form1.items.findIndex(item => {
          return item.thirdProductId === this.addDarenItem.thirdProductId
        })
        this.form1.items[index].darens = list.map(item => {
          return {
            douyinId: item.douyinId,
            commissionRate: item.commissionRate
          }
        });
        this.form1.items[index].errorDarens = '';
        console.log(this.form1,'this.form1')
        this.addExpertPopVisible = false
      }else if(this.type === 2) {
        this.form.items.forEach(item => {
          item.darens = list;
        });
      }
      this.oldDarens = []

    },
    handleAdd(item) {
      console.log(item,'handleAddhandleAdd===添加达人')
      this.addExpertPopVisible = true
      if(item) {
        this.oldDarens = item.darens;
        this.addDarenItem = item
      }else {
        this.addDarenItem = null
      }
    },
    handleDeleteList() {
      let checkedItems = this.form.items.filter(item => item.checked);
      if(checkedItems.length === 0) {
        this.$message({
          message: '请选择要关闭的计划',
          type: 'warning',
        })
        return
      }
      this.handleDelete(checkedItems)
    },
    async handleDelete(list) {
      console.log(list, 'item',this.formDefault[Number(this.activeName)])
      // return
      this.loading = true
      let planIdStr = list.map(item => item.planId).join(',')
      const res = await MiniModel.dyLifePlanClose({
        planIdStr: planIdStr,
        type: this.activeName,
      })
      this.loading = false
      if(res.data.code !== 200) {
        this.$message.error(res.data.message)
        return
      }
      let planIdList = planIdStr.split(',')
      let newItems = this.form.items.filter(item => {
        return !planIdList.includes(item.planId)
      })
      let newFormDefaultItem = this.formDefault[Number(this.activeName)].planDetails.filter(item => {
        return !planIdList.includes(item.planId)
      })
      this.$set(this.form,'items',newItems)
      this.$set(this.formDefault[Number(this.activeName)],'planDetails',newFormDefaultItem)
      console.log(newItems,'newItemsnewItems',this.form.items,this.formDefault)
      this.searchList = this.searchList.filter(item => {
        return !planIdList.includes(item.planId)
      })
      this.oldFormItems = this.oldFormItems.filter(item => {
        return !planIdList.includes(item.planId)
      })
      // this.form.items.splice(index,1)
      // this.formDefault[Number(this.activeName)].planDetails.splice(index,1)
      // const indexSearch = this.searchList.findIndex(item => item.planId === item.planId)
      // if (indexSearch > -1) {
      //   this.searchList.splice(index, 1)
      // }
      // const indexOldFormItems = this.oldFormItems.findIndex(item => item.planId === item.planId)
      // if (indexOldFormItems > -1) {
      //   this.oldFormItems.splice(index, 1)
      // }
      // if(this.oldFormItems.length && this.form.items.length === 0) {
      //   this.form.items = JSON.parse(JSON.stringify(this.oldFormItems))
      // }
      if(this.activeName == '1') {
        if(this.formDefault[Number(this.activeName)].planDetails.length === 0) {
          this.form.grantTimeArr = '';
          this.form.commissionDuration = '';
          this.formDefault[Number(this.activeName)].startTime = ''
          this.formDefault[Number(this.activeName)].endTime = ''
          this.formDefault[Number(this.activeName)].commissionDuration = ''
        }
      }
      this.$message.success(res.data.message)
    },
    handleBlur(e,index) {
      console.log(e, index, 'e,index111')
    },
    handleInput(e,index,typeStr) {
      console.log(e, index, typeStr,'e,index',this.type)
      if(this.type ===1) {
        if(typeStr === 'commissionRate') {
          if(this.activeName === '3') {
            if(!matchNegativePart3.test(e) || (Number(e) < 1 || Number(e) > 29)) {
              this.form1.items[index].error = '请输入1~29，最多1位小数';
            } else {
              this.form1.items[index].error = '';
            }
          }else{
            if(!matchNegativePart3.test(e) || (Number(e) < 1 || Number(e) > 29)) {
              this.form1.items[index].error = '请输入1~29，最多1位小数';
            } else {
              this.form1.items[index].error = '';
            }
          }
        }else if(typeStr === 'planName') {
          if(!e) {
            this.form1.items[index].errorNamne = '名称不能为空';
            return
          } else {
            this.form1.items[index].errorNamne = '';
          }
          if(e.length > 20) {
            this.form1.items[index].errorNamne = '名称不能超过20个字符';
          } else {
            this.form1.items[index].errorNamne = '';
          }
        }else if(typeStr === 'commissionDuration') {
          console.log(this.form1,'aaaaa==11',e)
          this.$forceUpdate()
          if(!matchIntegerNew.test(e)) {
            this.timeDayErr = '请输入正整数'
          } else {
            this.timeDayErr = '';
          }
        }
      }else if(this.type ===2) {
        if(typeStr === 'commissionRate') {
          if(this.activeName === '3'){
            if(!matchNegativePart3.test(e) || (Number(e) < 1 || Number(e) > 29)) {
              this.form.items[index].error = '请输入1~29，最多1位小数';
            } else {
              this.form.items[index].error = '';
            }
          }else{
            if(!matchNegativePart3.test(e) || (Number(e) < 1 || Number(e) > 29)) {
              this.form.items[index].error = '请输入1~29，最多1位小数';
            } else {
              this.form.items[index].error = '';
            }
          }
        }
        if(typeStr === 'commissionDuration') {
          this.$forceUpdate()
          console.log('rrt',e)
          if(!matchIntegerNew.test(e)) {
            this.timeDayErr = '请输入正整数'
          } else {
            this.timeDayErr = '';
          }
        }
      }
    },
    clearValidate() {
      this.timeErr = ''
      this.timeDayErr = ''
      this.form1.items.forEach(item => {
        item.error = '';
        item.errorNamne = '';
        item.errorDarens = '';
      });
      this.form.items.forEach(item => {
        item.error = '';
        item.checked = false
      });
      this.searchVal = ''
    },
    async validate1() {
      let errorMessage = ''
      if(this.form1.items.length === 0) {
        errorMessage = '请添加计划'
      }else{
        this.form1.items.forEach(item => {
          if(!item.planName || item.planName.length > 20) {
            item.errorNamne = '名称不能为空且不能超过20个字符';
            errorMessage = '名称不能为空且不能超过20个字符'
          }
          if(this.activeName === '3') {
            if(!matchNegativePart3.test(item.commissionRate) || (Number(item.commissionRate) < 1 || Number(item.commissionRate) > 29)) {
              item.error = '请输入1~29，最多1位小数';
              errorMessage = '请输入1~29，最多1位小数'
            }
          }
          if(this.activeName !== '3' && !item.darens.length) {
            item.errorDarens = '请添加达人';
            errorMessage = '请添加达人'
          } else {
            item.errorDarens = '';
          }
        });
      }
      if( this.activeName === '1') {
        if(!this.form1.grantTimeArr.length) {
          this.timeErr = '请选择开始时间和结束时间'
          errorMessage = '请选择开始时间和结束时间'
        }
        if(this.form1.commissionDuration === "" || !matchIntegerNew.test(this.form1.commissionDuration) ) {
          this.timeDayErr = '请输入正整数'
          errorMessage = '请输入正整数'
        }

      }
      console.log(errorMessage,'validate1')
      if(errorMessage) {
        this.$message.error(errorMessage)
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    },
    async validate() {
      this.timeErr = ''
      let errorMessage = ''
      if(this.form.items.length === 0) {
        console.log('=========111')
        errorMessage = '请添加计划'
      }else{
        console.log('=========222')
        if(this.activeName === '3'){
          this.form.items.forEach(item => {
            if(!matchNegativePart3.test(item.commissionRate) || (Number(item.commissionRate) < 1 || Number(item.commissionRate) > 29)) {
              item.error = '请输入1~29，最多1位小数';
              errorMessage = '请输入1~29，最多1位小数'
              return;
            }
          });
        }else{
          this.form.items.forEach(item => {
            if(!matchNegativePart3.test(item.commissionRate) || (Number(item.commissionRate) < 1 || Number(item.commissionRate) > 29)) {
              item.error = '请输入1~29，最多1位小数';
              errorMessage = '请输入1~29，最多1位小数'
              return;
            }
          });
        }

        console.log(this.form.grantTimeArr.length,'this.form.grantTimeArr.length',this.activeName)
        // if(!this.form.grantTimeArr.length && this.activeName === '1') {
        //   this.timeErr = '请选择开始时间和结束时间'
        //   errorMessage = '请选择开始时间和结束时间'
        // }
        // if(!matchIntegerNew.test(this.form.commissionDuration) && this.activeName === '1') {
        //   this.timeDayErr = '请输入正整数'
        //   errorMessage = '请输入正整数'
        // }
      }
      if(errorMessage) {
        this.$message.error(errorMessage)
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    },
    async submit() {
      // 新增
      if(this.type === 1) {
        await this.validate1()
        console.log(this.form1,'this.form1this.form1')
        let types = this.activeName
        let products = JSON.parse(JSON.stringify(this.form1.items))
        console.log(products,'productsproductsproducts')
        if(types == 3) {
          delete products.darens
        }
        if(types == 1) {
          products.forEach(item => {
            console.log(item,'item')
            item.darens.forEach((itemDaren => {
              itemDaren.startTime = this.form1.grantTimeArr[0]
              itemDaren.endTime = this.form1.grantTimeArr[1]
              itemDaren.commissionDuration = this.form1.commissionDuration
            }))
          })
        }
        let params = {
          appKey:localStorage.getItem("appKeyMini"),
          types:[{
            // startTime: types == 1 ? this.form1.grantTimeArr[0] : '',
            // endTime: types == 1 ?this.form1.grantTimeArr[1] : '',
            type: types,
            products:products,
            // commissionDuration: types == 1 ? this.form1.commissionDuration : '',
          }]
        }
        console.log(params,'paramsparams')
        // return
        this.loading = true
        this.submitLoading = true
        const res = await MiniModel.dyLifePlanCreate(params)
        console.log(res,'新增')
        this.submitLoading = false
        this.loading = false
        if(res.data.code !== 200) {
          this.$message.error(res.data.message)
          return
        }
        this.$message.success('创建成功')
        let datas = JSON.parse(JSON.stringify(products))
        this.$set(this.form1Default,Number(types)-1,datas)
        this.$emit('refresh')
        this.closeReset()
      }else if(this.type === 2) {
        await this.validate()
        let types = this.activeName
        let darenList = []
        let ids = []
        let newList = JSON.parse(JSON.stringify(this.form.items))
        console.log(this.searchList.length,'this.searchList.length')
        if((types == 1 || types == 2) && this.searchList.length) {
          this.searchList.forEach(item => {
            ids.push(item.planId)
          })
        }
        let filterOldFormItems = this.oldFormItems.filter(item => {
          return !ids.includes(item.planId)
        })
        let formList = filterOldFormItems.concat(newList)
        // this.form.items.forEach((item => {
        //   darenList.push({
        //     douyinId: item.douyinId,
        //     commissionRate: item.commissionRate,
        //   })
        // }))
        console.log(this.form,'this.formthis.form111')
        let list = formList.map(item => {
          return {
            planId: item.planId,
            planName: item.planName,
            thirdProductId: item.thirdProductId,
            versionCode: item.versionCode,
            commissionRate: item.commissionRate,
            startTime: types == 1 ? item.startTime : '',
            endTime:types == 1 ? item.endTime : '',
            darens: [{
              douyinId: item.douyinId,
              commissionRate: item.commissionRate,
            }]
          }
        })
        let products = JSON.parse(JSON.stringify(formList))
        console.log(products,'productsproductsproducts')
        if(types == 3) {
          products = list
        }else if(types == 1) {
          products = list
          products.forEach(item => {
            console.log(item,'item')
            item.darens.forEach((itemDaren => {
              itemDaren.startTime = item.startTime
              itemDaren.endTime = item.endTime
              itemDaren.commissionDuration = this.form1.commissionDuration
            }))
          })
        }else if(types == 2) {
          products = list
        }
        let params = {
          appKey:localStorage.getItem("appKeyMini"),
          types:[{
            // startTime: types == 1 ? this.form.grantTimeArr[0] : '',
            // endTime: types == 1 ?this.form.grantTimeArr[1] : '',
            type: types,
            products:products,
            // commissionDuration: types == 1 ? this.form.commissionDuration : '',
          }]
        }
        console.log(params,'paramsparams==编辑',this.formDefault,'this.form',this.form)
        // return
        this.submitLoading = true
        this.loading = true
        const res = await MiniModel.dyLifePlanEdit(params)
        console.log(res,'编辑====11')
        this.submitLoading = false
        if(res.data.code !== 200) {
          this.loading = false
          this.$message.error(res.data.message || '接口报错')
          return
        }
        this.$message.success('创建成功')
        // let datas = JSON.parse(JSON.stringify(products))
        // this.formDefault[Number(types)].planDetails = datas
        // if(types == '1'){
        //   this.form.grantTimeArr = this.formDefault[Number(types)] ? [this.formDefault[Number(types)].startTime, this.formDefault[Number(types)].endTime] : "";
        // }
        this.$emit('refresh')
        await this.getDetaile()
        this.loading = false
        this.closeReset()

      }
      // this.submitLoading = true
      console.log('通过')
      // this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     console.log("submit success!!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    onCancel() {
      this.dialogVisible = false;
    },
    handleChange(e) {
      console.log(e,'handleChange',typeof e.name,this.type)
      this.clearValidate()
      this.oldFormItems = []
      this.searchList = []
      if(this.type === 1) {
        this.form1.items = JSON.parse(JSON.stringify(this.form1Default[Number(e.name) - 1]))
      }else if(this.type === 2) {
        this.form.items = this.formDefault[Number(e.name)] ? JSON.parse(JSON.stringify(this.formDefault[Number(e.name)].planDetails)) : [];
        if(e.name === '1'){
          if(this.formDefault[Number(e.name)]) {
            this.form.grantTimeArr = this.formDefault[Number(e.name)].startTime ? [this.formDefault[Number(e.name)].startTime, this.formDefault[Number(e.name)].endTime] : "";
            this.form.commissionDuration = this.formDefault[Number(e.name)] ? this.formDefault[Number(e.name)].commissionDuration : '';
          }else{
            this.form.grantTimeArr = "";
            this.form.commissionDuration = '';
          }
        }
        console.log(this.formDefault[Number(e.name)],'aaaaa')
      }
      console.log('this.form1.items',this.form1,'this.form.items编辑',this.form)
    },
    closeReset() {
      this.dialogVisible = false;
    },
    handleClose() {
      console.log("右上角取消==1");
      this.closeReset();
    },
    reset() {
      this.form = {
        grantTimeArr:"",
        items :[]
      }
      this.form1 = {
        grantTimeArr:"",
        items :[]
      }
      this.timeErr = ''
      this.addDarenItem = null
      this.form1Default = []
      this.formDefault = {}
      this.activeName = '3'
      this.submitLoading = false
      this.clearValidate()
    },
    async getDetaile() {
      this.form.grantTimeArr = "";
      this.form.items = []
      this.form.commissionDuration = '';
      this.oldFormItems = []
      this.searchList = []
      this.searchVal = ''
      // type类型：1短视频定向，2直播定向，3通用
      const res = await MiniModel.dyLifePlanGoodsPlan({
        thirdProductId: String(this.rowList.thirdProductId),
      })
      console.log(res,'res=====')
      if(res.data.code !== 200) {
        console.log('res=====111',res.data.code)
        this.$message({
          type:'error',
          message: res.data.message || res.data.code
        });
        return;
      }
      for(let key in res.data.data) {
        res.data.data[key].planDetails.forEach(item => {
          item.error = '';
          item.checked = false
        })
        if(res.data.data[key].planDetails.length) {
          this.planDetails = res.data.data[key].planDetails
        }
      }
      this.formDefault = res.data.data;
      this.form.items = res.data.data[Number(this.activeName)] ? JSON.parse(JSON.stringify(res.data.data[Number(this.activeName)].planDetails)) : []
      if(this.activeName === '1') {
        console.log('aaaa=========234')
        if(res.data.data[Number(this.activeName)]) {
          this.form.grantTimeArr = res.data.data[Number(this.activeName)].startTime ? [res.data.data[Number(this.activeName)].startTime, res.data.data[Number(this.activeName)].endTime] : "";
          this.form.commissionDuration = res.data.data[Number(this.activeName)].commissionDuration
        }else{
          this.form.grantTimeArr = "";
          this.form.commissionDuration = '';
        }
      }

      console.log(res.data.data,'管理计划res',this.form)
    },
    async open(type,row) {
      console.log(type, row, 'open===type,row')
      this.reset()
      // type 2计划管理
      this.type = type
      this.dialogVisible = true
      // 添加计划
      if(type === 1) {
        this.rowAdd = row
        this.title = '添加计划推广'
        let {startTime, endTime} = this.getTime();
        this.form1.grantTimeArr = [startTime, endTime];
        this.form1.commissionDuration = '7';
        this.form1.items = row.map(item => {
          return {
            // ...item,
            thirdProductId:item.thirdProductId,
            productName:item.productName,
            versionCode:item.versionCode,
            commissionRate: '',
            planName:'', //计划名称
            darens:[],//达人列表
            errorNamne: '',
            error:'',
            timeErr:'',
            errorDarens:'',
          }
        })
        let data = JSON.parse(JSON.stringify(this.form1.items))
        this.form1Default = [data,data,data]
        console.log(this.form1Default,'this.form1Default')
      }else if(type === 2) {
        this.rowList = row
        this.loading = true
        // 管理计划
        this.title = '计划管理'
        // const res = await MiniModel.dyLifePlanGoodsPlan({
        //   thirdProductId: String(row.thirdProductId),
        // })
        await this.getDetaile(row.thirdProductId)
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="less">
/deep/.el-dialog.import-dialog {
  max-height: calc(100vh - 100px) !important;
  // max-height: 800px;
  overflow-y: auto;
  background: #f5f5f5;
  z-index: 999 !important;
  // margin: auto !important;
}
.box{
  background: #fff;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
}
.title{
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.row{
  display: flex;
}
.header-text{
  margin-right: 30px;
}
.btns-coantainer{
  //position: absolute;
  //bottom: 30px;
  //right: 40px;
  z-index: 99;
  //width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.list-container{
  height: calc(100vh - 440px);
  overflow-y: auto;
}
.list-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list{
  margin-top: 10px;
  padding: 16px 10px;
  .item{
    display: flex;
    justify-content: space-between;
  }
}
.add{
  color: #409EFF;
  cursor: pointer;
  text-align: right;
}
.item-box{
  //width: 200px;
  display: flex;
  padding-top: 10px;
  //flex: 1;
  //align-items: center;
}
.item-box-left{
  width: 70px;
}
.item-box-right{
  width: 150px;
  color: #333;
}
.picker-container{
  position: absolute;
  left: 0px;
  bottom: 60px;
  background: #fff;
  width: 98%;
  display: flex;
}
.header-num{
  color: #52c41a;
  display: flex;
  margin-right: 30px;
  .yuan{
    background: #52c41a;
  }
}
.header-set{
  color: #1677ff;
  display: flex;
  .yuan{
    background: #1677ff;
  }
}
.yuan{
  width: 20px;
  height: 20px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
.no-data-text{
  color: #999;
  margin-top: 10px;
}

.items-row:not(:last-child) {
  border-bottom: 1px dashed #ccc;
}
.batchSet{
  display: flex;
  align-items: center;
  color: #1677ff;
}
.search-container{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/manageDetailPop.vue